import React from "react";
import { steps, contact } from "../../mock";
import { SectionHeading } from "../SectionHeading";
import Reveal from "../Reveal";
import { MessageCircle } from "lucide-react";

const HowToStart = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <div className="glow-blob w-80 h-80 bg-[#00ff87] bottom-0 left-1/3" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading
          eyebrow="Get Started"
          title="How to Start with"
          highlight="DaddyAnna"
          subtitle="Get your online cricket id in 4 simple steps. The whole process is 100% manual and secure — no bots, no delays."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.step} delay={i * 100}>
              <div className="relative card-neon rounded-2xl p-7 h-full">
                <span className="font-tech text-5xl font-bold text-[#00ff87]/15 absolute top-4 right-5">
                  {s.step}
                </span>
                <div className="h-11 w-11 grid place-items-center rounded-full bg-[#00ff87] text-black font-display font-bold mb-5">
                  {i + 1}
                </div>
                <h3 className="font-display font-semibold text-lg text-white mb-2">{s.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={contact.whatsapp}
            target="_blank"
            rel="noreferrer"
            className="btn-neon inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl font-display font-semibold"
          >
            <MessageCircle size={20} /> Message "Get Cricket ID"
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowToStart;
